import { CdkDialogContainer } from '@angular/cdk/dialog';
import { CdkPortalOutlet } from '@angular/cdk/portal';
import { ChangeDetectionStrategy, Component } from '@angular/core';
import { UIKitDefaultDialogConfig } from './dialog-config';

@Component({
  selector: 'uikit-dialog-container',
  imports: [CdkPortalOutlet],
  styles: [
    `
      @use 'tokens' as t;
      :host {
        display: block;
        background: #fff;
        border-radius: var(--insight-dialog-border-radius);
        width: 100%;
        z-index: 20000;
        overflow: hidden;
        position: relative;
        @include t.shadow-box();
        &:has(.dialog-actions) {
          padding-bottom: 64px;
        }
        &:focus-visible {
          outline: none;
        }
      }
    `,
  ],
  template: `
    <ng-template cdkPortalOutlet></ng-template>
  `,
  changeDetection: ChangeDetectionStrategy.Eager,
})
export class UIKitDialogContainer extends CdkDialogContainer<UIKitDefaultDialogConfig> {}
